import { render, staticRenderFns } from "./claim-items.vue?vue&type=template&id=727e2e20&"
import script from "./claim-items.vue?vue&type=script&lang=js&"
export * from "./claim-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports